<template>
  <div>
    <v-btn small outlined color="primary" @click="dialog = true">
      <v-icon small class="mr-2">mdi-layers-plus</v-icon>Add map layer
    </v-btn>
    <v-dialog v-model="dialog" max-width="420">
      <v-card>
        <v-card-title>Add map layer</v-card-title>
        <v-card-text>
          <v-text-field v-model="layerName" label="Layer name" dense></v-text-field>
          <v-file-input
            v-model="file"
            label="CSV file"
            accept=".csv,text/csv"
            dense
            @change="error = null"
          ></v-file-input>
          <v-alert v-if="error" type="error" outlined dense>{{ error }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn text color="primary" :disabled="!file" @click="handleAdd">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { parseMapLayerCsv } from "@/plugins/mapLayerCsv";

export default {
  name: "MapLayerUpload",
  props: {},
  data() {
    return {
      dialog: false,
      layerName: "",
      file: null,
      error: null,
    };
  },
  methods: {
    async handleAdd() {
      try {
        const text = await this.file.text();
        const layer = parseMapLayerCsv(text, { name: this.layerName || this.file.name });
        this.$emit("add-layer", layer);
        this.dialog = false;
        this.layerName = "";
        this.file = null;
        this.error = null;
      } catch (error) {
        this.error = error.message;
      }
    },
  },
};
</script>

<style></style>
